export const DEFAULT_REVIEWS_TOTAL_THRESHOLD = 5

export const VILLAS_REVIEWS_TOTAL_THRESHOLD = 5

// Rating threshold for showing positive recommendation (thumbs up vs thumbs down)
export const RECOMMENDED_RATING_THRESHOLD = 6

// Property-level overrides for hiding the AI-generated review summary on offer pages.
export const OFFER_PAGE_REVIEW_AI_SUMMARY_DISABLED_PROPERTY_IDS: Set<string> = new Set([
  'c1959500-a97b-11ec-903e-dd9847157c55', // Sea World Resort
])

export type ReviewPanelSortType = 'newest' | 'best_rating' | 'worst_rating' | 'recommend'

// Map rating distribution range to filter value
export const RATING_RANGE_TO_FILTER_MAP: Record<string, string> = {
  '9.0+': 'exceptional',
  '7.0-9.0': 'good',
  '5.0-7.0': 'okay',
  '3.0-5.0': 'poor',
  '1.0-3.0': 'very-poor',
}

export function isOfferPageReviewAiSummaryDisabled(propertyId?: string): boolean {
  return !!propertyId && OFFER_PAGE_REVIEW_AI_SUMMARY_DISABLED_PROPERTY_IDS.has(propertyId)
}
